import './App.scss';
import '../i18n';
import {ThemeProvider} from '@mui/material';
import {AppContextProvider} from '../contexts/app/provider';
import {AppContextType} from '../contexts/app/types';
import Navigation from './Navigation';
import {AppContext} from '../contexts/app/context';
import {AuthContextProvider} from '../contexts/auth/provider';
import {SnackBarContextProvider} from '../contexts/snack-bar/provider';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {OfficeContextProvider} from '../contexts/office/provider';
import {AuxiliaryDataCacheContextProvider} from '../contexts/auxiliary-data-cache/provider';
import {EntityContextProvider} from '../contexts/entity/provider';
import {ExportDataProvider} from '../contexts/export-data/provider';

export default function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <AppContextProvider>
        <AppContext.Consumer>
          {(appContext: AppContextType) => (
            <ThemeProvider theme={appContext.state.currentTheme}>
              <OfficeContextProvider>
                <SnackBarContextProvider>
                  <AuthContextProvider>
                    <EntityContextProvider>
                      <AuxiliaryDataCacheContextProvider>
                        <ExportDataProvider>
                          <Navigation />
                        </ExportDataProvider>
                      </AuxiliaryDataCacheContextProvider>
                    </EntityContextProvider>
                  </AuthContextProvider>
                </SnackBarContextProvider>
              </OfficeContextProvider>
            </ThemeProvider>
          )}
        </AppContext.Consumer>
      </AppContextProvider>
    </LocalizationProvider>
  );
}
